import { Injectable, EventEmitter } from '@angular/core';
import { ProfileService } from '../../../core/profile/profile.service';
import { ApiWebService } from '../../../api/api/ApiWebService';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { dataTable, filterDetail } from '../../../models/column-types';

@Injectable({
  providedIn: 'root'
})
export class TableRequestService {
  reloadAction: EventEmitter<boolean> = new EventEmitter<boolean>();
  reloadSearchAction: EventEmitter<filterDetail[]> = new EventEmitter<filterDetail[]>();
  skip: number = 0;
  filter: string = '';
  order: string = '';
  isCached: boolean;
  currentFilter: string = '';

  constructor(
    private _webService: ApiWebService,
    private _profile: ProfileService,
    private _route: Router) { }

  getData(filter?: string, endpoint?: string, order?: string, changePage: boolean = false, isMultiple: boolean = false, concatFilter: boolean = false): Observable<dataTable> {
    this.isCached = false;
    this.validateCache();
    if ((!this.isCached && !changePage) || isMultiple) {
      this.filter = filter ? filter : '';
      if (concatFilter && filter && this.currentFilter) {
        this.filter = `${this.currentFilter} and ${filter}`;
      }
      this.order = order;
      this.skip = 0;
    }
    this.disableCache();
    this.currentFilter = this.filter;
    return this._webService.GetWithHttpInfo(this._profile.getToken(), endpoint, 10, this.skip, this.filter, null, 'allpages', order);
  }

  getPage(): string {
    const page = this.skip.toString().slice(0, -1);
    return page;
  }

  getService(): ApiWebService {
    return this._webService;
  }

  activateCache(): void {
    this.isCached = true;
  }

  disableCache(): void {
    this.isCached = false;
  }

  validateCache(): void {
    const route = sessionStorage.getItem('actualRoute');

    if (this._route.url === route) this.activateCache();
    sessionStorage.removeItem('actualRoute');
  }

  reLoadTable(): void {
    this.reloadAction.emit(true);
  }

  reLoadInputs(inputs: filterDetail[]): void {
    this.reloadSearchAction.emit(inputs);
  }
}
